import { render, staticRenderFns } from "./NsTopnavNavigation.vue?vue&type=template&id=17c55aa5&scoped=true&"
import script from "./NsTopnavNavigation.vue?vue&type=script&lang=js&"
export * from "./NsTopnavNavigation.vue?vue&type=script&lang=js&"
import style0 from "./NsTopnavNavigation.vue?vue&type=style&index=0&id=17c55aa5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c55aa5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c55aa5')) {
      api.createRecord('17c55aa5', component.options)
    } else {
      api.reload('17c55aa5', component.options)
    }
    module.hot.accept("./NsTopnavNavigation.vue?vue&type=template&id=17c55aa5&scoped=true&", function () {
      api.rerender('17c55aa5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsTopnavNavigation.vue"
export default component.exports